import {createRouter, createWebHistory, RouteRecordRaw} from 'vue-router'
import {checkAuth, logout} from "@/services/auth.service";
import {getCurrentAccount} from "@/services/account.service";

const routes: Array<RouteRecordRaw> = [
    {
        path: '/',
        redirect: '/dashboard'
    },
    {
        path: '/dashboard',
        name: 'dashboard',
        component: () => import('../views/Private/Dashboard.vue'),
        meta: {layout: 'AppLayout', requiresAuth: true},
    },
    {
        path: '/statistics',
        name: 'statistics',
        component: () => import('../views/Private/Statistics.vue'),
        meta: {layout: 'AppLayout', requiresAuth: true, roles: ['owner', 'admin']},
    },
    {
        // MAX-2 §5: клиенты из мессенджера — номера телефона в разделе нет.
        path: '/clients',
        name: 'clients',
        component: () => import('../views/Private/Clients.vue'),
        meta: {layout: 'AppLayout', requiresAuth: true, roles: ['owner', 'admin']},
    },
    {
        path: '/remote-machine-start',
        name: 'remote-machine-start',
        component: () => import('../views/Private/RemoteMachineStart.vue'),
        meta: {layout: 'AppLayout', requiresAuth: true},
    },
    {
        // И-1: касса точки (остаток, выемки, инкассации) — owner/admin.
        path: '/cashbox',
        name: 'cashbox',
        component: () => import('../views/Private/CashBox.vue'),
        meta: {
            layout: 'AppLayout',
            requiresAuth: true,
            roles: ['owner', 'admin']
        },
    },
    {
        // Т-РЕЕСТР: задачи сети — owner/admin, mobile-first.
        path: '/tasks',
        name: 'tasks',
        component: () => import('../views/Private/Tasks.vue'),
        meta: {
            layout: 'AppLayout',
            requiresAuth: true,
            roles: ['owner', 'admin']
        },
    },
    {
        // У-ЛК-1: ручной ввод операций учёта — owner/admin.
        path: '/finance',
        name: 'finance',
        component: () => import('../views/Private/Finance.vue'),
        meta: {
            layout: 'AppLayout',
            requiresAuth: true,
            roles: ['owner', 'admin']
        },
    },
    {
        // Р-1: архив старой системы «Вяткиcom» (2019-2026) — owner/admin.
        path: '/archive',
        name: 'archive',
        component: () => import('../views/Private/Archive.vue'),
        meta: {
            layout: 'AppLayout',
            requiresAuth: true,
            roles: ['owner', 'admin']
        },
    },
    {
        // ДОЗ-2: машины и сушилки точки, реле дозатора — owner/admin.
        path: '/washing-machines',
        name: 'washing-machines',
        component: () => import('../views/Private/WashingMachines.vue'),
        meta: {
            layout: 'AppLayout',
            requiresAuth: true,
            roles: ['owner', 'admin']
        },
    },
    {
        path: '/employees',
        name: 'employees',
        component: () => import('../views/Private/Employees.vue'),
        meta: {
            layout: 'AppLayout',
            requiresAuth: true,
            roles: ['owner', 'admin']
        },
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/Auth/Login.vue'),
        meta: {layout: 'DefaultLayout'},
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => import('../views/Auth/Login.vue'),
        beforeEnter: () => {
            logout();
            return {name: 'login'};
        },
        meta: {
            layout: 'DefaultLayout',
        },
    },
    {
        path: "/:pathMatch(.*)*",
        name: "not-found",
        component: () => import("@/views/NotFound.vue"),
        meta: {
            layout: 'DefaultLayout',
        },
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})

router.beforeEach(async (to) => {
    if (to.name === 'login' && checkAuth()) {
        return {name: 'dashboard', replace: true};
    }

    if (!to.meta.requiresAuth) return true;

    if (!checkAuth()) {
        return {
            name: 'login',
            query: {redirect: to.fullPath}
        };
    }

    const roles = Array.isArray(to.meta.roles)
        ? to.meta.roles as string[]
        : [];

    if (roles.length === 0) return true;

    try {
        const account = await getCurrentAccount();
        return roles.includes(account.role)
            ? true
            : {name: 'dashboard'};
    } catch (error) {
        logout();
        return {
            name: 'login',
            query: {redirect: to.fullPath}
        };
    }
});

export default router
